import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, normalizeStyle as _normalizeStyle, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

import { CheckBoxComponent } from "@syncfusion/ej2-vue-buttons";
import { computed, ref, watch } from "vue";

interface Props {
  modelValue?: boolean;
  placeholder?: string;
  disabled?: boolean;
  width?: string;
}

// eslint-disable-next-line @typescript-eslint/no-unused-vars

export default /*@__PURE__*/_defineComponent({
  __name: 'SogCheckBox',
  props: {
    modelValue: { type: Boolean, default: undefined },
    placeholder: { default: undefined },
    disabled: { type: Boolean, default: false },
    width: { default: undefined }
  },
  emits: ["update:modelValue"],
  setup(__props: any, { emit: __emit }) {

const props = __props;

// eslint-disable-next-line @typescript-eslint/no-unused-vars
const emit = __emit;

const _value = ref(false);

watch(
  props,
  () => {
    _value.value = props.modelValue ?? false;
  },
  { immediate: true }
);

const _style = computed<string>(() => (props.width ? "width: " + props.width : ""));

function onChange(args: { checked: boolean }) {
  _value.value = args.checked;
  emit("update:modelValue", _value.value);
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: "sog-checkbox",
    style: _normalizeStyle(_style.value)
  }, [
    _createVNode(_unref(CheckBoxComponent), {
      checked: _value.value,
      label: __props.placeholder,
      disabled: __props.disabled,
      onChange: onChange
    }, null, 8, ["checked", "label", "disabled"])
  ], 4))
}
}

})